import { render } from "./Mail.vue?vue&type=template&id=9a78ca00"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"

import "./Mail.vue?vue&type=style&index=0&id=9a78ca00&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__